exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1QCcmMSKn3ROaxTxrIm7Mw{display:-ms-flexbox;-ms-align-items:center;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/atoms/FlexAlign/style.css"],"names":[],"mappings":"AAAA,yBACC,oBAAqB,AAClB,uBAAwB,AACxB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,mBAAoB,AAChB,cAAgB,CACvB","file":"style.css","sourcesContent":[".flexAlign {\n\tdisplay: -ms-flexbox;\n    -ms-align-items: center;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"flexAlign": "_1QCcmMSKn3ROaxTxrIm7Mw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/atoms/FlexAlign/style.css
// module id = 800
// module chunks = 0 1 2 3 15 16